<template>
  <div class="page">
    <div style="
      margin: auto;
      width: 1200px;
      height: 109px;
          z-index: 1000">
      <div style="color: #FFFFFF; font-size: 30px;font-family: 微软雅黑; font-weight: bold ;padding-top:35px">{{
          this.systemName
        }}
      </div>
    </div>
    <div style="width:100%;background-color: #004e96; height: 65px">
      <div
        style=" font-weight: bold;width: 1200px;margin: auto"
      >
        <navigation-bar :default-active="'关于我们'"/>
      </div>
    </div>
    <div  style="margin-top: 10px;">
    <div style="width: 1200px;margin: auto;background-color: #FFFFFF;min-height: 500px">
    <el-row v-if="imp1" style="text-align: center">
      <el-col style="margin-top: 40px" :span="15" :offset="3">
        <span>暂无数据</span>
      </el-col>
    </el-row>
    <el-row style="text-align: center" v-if="imp2">
        <span
          style="line-height:1.5;font-size: 15px; text-indent: 40px; margin-top: 20px"
        >
          <div v-html="data.usContent"></div>
        </span>
    </el-row>
    </div>
    </div>
  </div>
</template>
<script>
import request from "../../utils/request";
import { getSystemId, getSystemName } from "../../utils/systemInfo";
import NavigationBar from "./compoment/navigationBar";

export default {
  name: "about",
  components: { NavigationBar },
  data() {
    return {
      imp2:false,
      imp1: true,
      imp: "",
      input: "",
      imageUrlTop: require("../../../static/image/home.jpg"),
      data: {},
      index: "",
      systemName: getSystemName(),
    };
  },
  methods: {
    toSearch() {
      this.$router.push({ path: "/standard", query: { input: this.input } });
    },
    getDataList() {
      request({
        url: "/portalAbout/getByBelong",
        methods: "get",
        params: {
          belong: getSystemId(),
        },
      }).then((rsp) => {
        if (rsp.resultCode == "0") {
          if (rsp.data != "" && rsp.data != null) {
            this.data = rsp.data;
          }
          this.imp1=false;
          this.imp2=true;
        } else {
          this.$message({
            message: "请求数据错误",
            type: "error",
            duration: 2000,

          });
        }
      });
    },
  },
  mounted() {
    document.title = this.systemName;
    this.getDataList();
  },
  created() {
    this.index = this.$route.query.name;
  },
};
</script>
<style>
.el-menu-item.is-active {
  background: #045fb4;
}
.el-menu.el-menu--horizontal {
  border-bottom: 0;
}
</style>
<style scoped>
.page{
  background: url("../../../static/image/body-bg.jpg") no-repeat;
  height: 100%;
  width: 100%;
  background-size:100% 775px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/about.vue